"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3array = require("d3-array");
var models_1 = require("./models");
exports.getInitialValue = function (metricValues) {
    if (metricValues && metricValues.length) {
        return metricValues[metricValues.length - 1];
    }
    else {
        return undefined;
    }
};
exports.calculateComparison = function (table, currentValue) {
    if (currentValue === undefined) {
        return undefined;
    }
    var idx = table
        .findIndex(function (value) { return value.timestamp.valueOf() === currentValue.timestamp.valueOf() && value.measure === currentValue.measure; });
    if (idx <= 0) {
        return undefined;
    }
    var comparedPoint = table[idx - 1];
    var previous = comparedPoint.measure;
    var absolute = currentValue.measure - previous;
    var percentage = absolute === 0 ? 0 : (absolute / previous);
    return {
        absolute: absolute,
        percentage: percentage,
        comparedPoint: comparedPoint,
    };
};
exports.generatePillValues = function (roles, table, currentValue) {
    var value = currentValue || exports.getInitialValue(table);
    var comparison = table && value ? exports.calculateComparison(table, value) : undefined;
    return mapRolesToValues(roles, value ? value.measure : 0, comparison);
};
var mapRolesToValues = function (roles, value, comparison) {
    return roles
        .map(function (role) {
        switch (role) {
            case models_1.MetricValueRole.CURRENT:
                return { role: role, value: value };
            case models_1.MetricValueRole.ABSOLUTE_CHANGE:
                return comparison ? { role: role, value: comparison.absolute } : undefined;
            case models_1.MetricValueRole.PERCENTAGE_CHANGE:
                return comparison ? { role: role, value: comparison.percentage } : undefined;
            default: return undefined;
        }
    })
        .filter(function (element) { return element !== undefined; });
};
exports.parseDateTrunc = function (qualifiedName) {
    // Qualified names look like this:
    // [dataengine.42019.618651678240].[tyr:Order Date:qk]
    // For Date Trunc fields, the `tyr` there is what we're looking for.
    // Take a look at http://l/datetruncs for more info.
    var regex = /\.\[(.{3,4})\:/;
    // That is:
    // \. a literal period
    // \[ a literal open square brace
    // (.{3,4}) capture 3 or 4 characters
    // \: a literal colon
    var match = regex.exec(qualifiedName);
    if (match) {
        switch (match[1]) {
            case 'tyr':
                return models_1.DateTrunc.YEAR;
            case 'tqr':
                return models_1.DateTrunc.QUARTER;
            case 'tmn':
                return models_1.DateTrunc.MONTH;
            case 'tdy':
                return models_1.DateTrunc.DAY;
            case 'thr':
                return models_1.DateTrunc.HOUR;
            case 'tmi':
                return models_1.DateTrunc.MINUTE;
            case 'tsc':
                return models_1.DateTrunc.SECOND;
            case 'twk':
                return models_1.DateTrunc.WEEK;
            case 'tiyr':
                return models_1.DateTrunc.ISO_YEAR;
            case 'tiqr':
                return models_1.DateTrunc.ISO_QTR;
            case 'tiwk':
                return models_1.DateTrunc.ISO_WEEK;
            case 'tiwd':
                return models_1.DateTrunc.ISO_WEEKDAY;
            default: return models_1.DateTrunc.UNKNOWN;
        }
    }
    return models_1.DateTrunc.UNKNOWN;
};
exports.measureDomainToRender = function (data) {
    var measureDomain = d3array.extent(data, function (p) { return p.measure; });
    return exports.adjustMeasureDomain(measureDomain);
};
/**
 * This function creates an adjusted domain for the measure axis.
 *
 * It follows a few heuristics:
 * - Don't cross the 0 line unless the data does
 * - Leave some space above/below the value furthest from zero (currently 10%)
 * - Aim for "the golden ratio" for space between the value closest to zero and the edge of the chart
 *
 * @param measureDomain the domain of the data
 */
exports.adjustMeasureDomain = function (measureDomain) {
    if (measureDomain[0] === undefined) {
        return [0, 1];
    }
    var dataMin = measureDomain[0], dataMax = measureDomain[1];
    var measureDiff = Math.abs(dataMax - dataMin);
    var margin = measureDiff * 0.1;
    if (dataMin < 0 && dataMax > 0) {
        return [dataMin - margin, dataMax + margin];
    }
    if (dataMin === 0) {
        return [dataMin, dataMax + margin];
    }
    if (dataMax === 0) {
        return [dataMin - margin, dataMax];
    }
    if (dataMin > 0) {
        var scaleMax = dataMax + margin;
        return [goldenRatioClampedToZero(dataMin, scaleMax), scaleMax];
    }
    else {
        var scaleFurthestFromZero = dataMin - margin;
        return [scaleFurthestFromZero, goldenRatioClampedToZero(dataMax, scaleFurthestFromZero)];
    }
};
var goldenRatioClampedToZero = function (closestToZero, scaleFurthestFromZero) {
    if (closestToZero === 0) {
        return 0;
    }
    // See https://www.chezvoila.com/blog/yaxis
    var idealValue = (3 * closestToZero - scaleFurthestFromZero) / 2;
    if ((closestToZero > 0 && idealValue < 0) || (closestToZero < 0 && idealValue > 0)) {
        // clamp to zero if the ideal value would cross the zero line
        return 0;
    }
    return idealValue;
};
exports.timeDomainToRender = function (data) {
    return d3array.extent(data, function (p) { return p.timestamp; });
};
exports.getDateRange = function (table) {
    if (table.length === 0) {
        return undefined;
    }
    var firstPoint = table[0];
    var lastPoint = table[table.length - 1];
    return {
        first: firstPoint.timestamp,
        last: lastPoint.timestamp,
    };
};
//# sourceMappingURL=engine.js.map